"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.OverlayDefaultFooter = void 0;
require("./OverlayDefaultFooter.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * OverlayDefaultFooter component
 *
 * @method
 * @param { OverlayDefaultFooterProps } props
 * @returns OverlayDefaultFooter
 */

const OverlayDefaultFooter = props => {
  const {
    externalFooterChildrenElements,
    showFooterDivider,
    supportText
  } = props;
  if (!externalFooterChildrenElements) {
    return;
  }
  const componentClassName = (0, _classnames.default)('pal-c-OverlayDefaultFooter', {
    'pal-c-OverlayDefaultFooter--showFooterDivider': showFooterDivider
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalFooterChildrenElements && (0, _renderObject.renderObject)(externalFooterChildrenElements), supportText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body-sm",
    textAlign: "left",
    textColor: "xsubtle"
  }, supportText));
};

/**
 * Property type definitions
 * @typedef OverlayDefaultFooterProps
 * @type {object}
 * @property {object} externalFooterChildrenElements - Footer ActionGroupDefault passed from web-site with additional logic.
 * @property {boolean} showFooterDivider - Flag to show divider between body and footer.
 * @property {string} supportText - Displays support text below the footer actions.
 */
exports.OverlayDefaultFooter = OverlayDefaultFooter;
const propTypes = exports.propTypes = {
  /**
   * Footer ActionGroupDefault passed from web-site with additional logic.
   */
  externalFooterChildrenElements: _propTypes.default.object,
  /**
   * Flag to show divider body and footer.
   */
  showFooterDivider: _propTypes.default.bool,
  /**
   * Displays support text below the footer actions.
   */
  supportText: _propTypes.default.string
};
OverlayDefaultFooter.propTypes = propTypes;
var _default = exports.default = OverlayDefaultFooter;